/*
 * Most Visited Articles Constants
 */

export const LOAD_RECOMMENDATIONS = 'myarchdaily/MostVisitedArticles/LOAD_RECOMMENDATIONS';
export const LOAD_RECOMMENDATIONS_SUCCESS = 'myarchdaily/MostVisitedArticles/LOAD_RECOMMENDATIONS_SUCCESS';
export const LOAD_RECOMMENDATIONS_ERROR = 'myarchdaily/MostVisitedArticles/LOAD_RECOMMENDATIONS_ERROR';

export const LOAD_RECOMMENDATIONS_PRODUCTS = 'myarchdaily/MostVisitedArticles/LOAD_RECOMMENDATIONS_PRODUCTS';
export const LOAD_RECOMMENDATIONS_PRODUCTS_SUCCESS = 'myarchdaily/MostVisitedArticles/LOAD_RECOMMENDATIONS_PRODUCTS_SUCCESS';
export const LOAD_RECOMMENDATIONS_PRODUCTS_ERROR = 'myarchdaily/MostVisitedArticles/LOAD_RECOMMENDATIONS_PRODUCTS_ERROR';
